/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_itemSearch = {
    readonly filters: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_filters">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_itemSearch" | "SbSharedSkyscraperAd_itemSearch">;
    readonly " $refType": "SbRespRefineMenuSelector_itemSearch";
};
export type SbRespRefineMenuSelector_itemSearch$data = SbRespRefineMenuSelector_itemSearch;
export type SbRespRefineMenuSelector_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuSelector_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuSelector_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenu_filters"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedSkyscraperAd_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'bcff1f9c493774ef98e38edc26eb899b';
export default node;
